window.pw = $.extend(window.pw, {
    doc: function () {
        this.m = this.m || {};
        if (arguments[0] && arguments[1]) {
            var n = arguments[0];
            this.m[arguments[0]] = {
                version: arguments[1],
                info: arguments[2]
            }
        }
        if(arguments.length === 0) {
            console.table(this.m);
        }

    }
});

console.debug = function () {
    // todo Debugowanie tylko w trybie developerskim.
    for (var i = 0; i < arguments.length; i++) {
        console.log('%c' + arguments[0], 'color: green;');
    }
};


(function ($, pw) {

    "use strict";

    pw.doc('Core', '1.2.180111');

    var flashMessengerContainer = $('#flashMessenger');

    /**
     *
     * @param data
     * @param wrapper
     * @param useMethod  set|append|prepend
     */
    pw.ajaxContent = function (data, wrapper, useMethod) {

        var uiData = $('<html />').html(data),
            htmlData = uiData.find('#ajaxContent').html(),
            dataPre = uiData.find('#ajaxPre').html(),
            modals = uiData.find('.modal'),
            flashMessenger = uiData.find('#ajaxFlashMessenger').html(),
            method = useMethod || 'set'
        ;

        if (modals.length) {
            // Remove Exists modals
            modals.each(function () {
                var id = $(this).attr('id');
                if (id) {
                    console.debug('Modal #' + id + ' will be replaced.');
                    $('body').find('#' + id).remove();
                }
            });
        }

        if (wrapper) {
            switch (method) {
                case 'append' :
                    wrapper.append(htmlData);
                    break;
                case 'prepend' :
                    wrapper.prepend(htmlData);
                    break;
                default:
                    wrapper.html(htmlData);

            }
            wrapper.removeClass('loading');
        }

        if (dataPre) {
            $('body').append(dataPre);
            $('.pw-pre:last').addClass('ajax');
        }

        if ($.material) {
            $.material.init();
        }

        if (flashMessenger) {
            flashMessengerContainer
                .append(flashMessenger)
                .trigger('flash:message');
        }

        if (wrapper) {
            wrapper.trigger('pw.segment.postLoad', [wrapper]);
            wrapper.trigger('ajax:postLoad', [wrapper]);
        }
    };

    pw.ajaxSections = function (data) {

        var uiData = $('<html />').html(data),
            sections = uiData.find('#ajaxContent [data-section]'),
            dataPre = uiData.find('#ajaxPre').html(),
            modals = uiData.find('.modal'),
            flashMessenger = uiData.find('#ajaxFlashMessenger').html()
        ;

        sections.each(function () {
           var e = $(this),
               sectionId = e.attr('data-section');
           console.debug(sectionId);
           if(sectionId) {
               $('[data-section="'+ sectionId +'"]').html(e.html()).removeClass('loading');
           }

        });

        if (dataPre) {
            $('body').append(dataPre);
            $('.pw-pre:last').addClass('ajax');
        }

        if ($.material) {
            $.material.init();
        }

        if (flashMessenger) {
            flashMessengerContainer
                .append(flashMessenger)
                .trigger('flash:message');
        }

    };

    /**
     *
     * @param dom
     * @param notRemoveDataPrefix
     * @returns {{}}
     */
    pw.getDataAttributes = function (dom, notRemoveDataPrefix) {
        var attributes = {};
        $.each(dom.get(0).attributes, function (i, attrib) {
            if (attrib.name.match("^data-")) {
                if (notRemoveDataPrefix !== undefined && notRemoveDataPrefix) {
                    attributes[attrib.name] = attrib.value;
                } else {
                    attributes[attrib.name.slice(5)] = attrib.value;
                }

            }
        });
        return attributes;
    };

    pw.flashMessenger = function (flashMessenger) {
        if (flashMessenger) {
            flashMessengerContainer
                .append(flashMessenger)
                .trigger('flash:message');
        }
    };

    var oldAjax = $.ajax;

    $.ajax = function (opts) {
        return $.Deferred(function () {

            var _def = this;

            oldAjax
                .call(this, opts)
                .done(function (res) {

                    if (res.__flashMessenger__) {
                        pw.flashMessenger(res.__flashMessenger__);
                        // delete res.__flashMessenger__;
                    }

                    _def.resolve(res);
                    // else _def.reject("timeout");
                })
                .fail(function () {
                    _def.reject();
                });
        });
    };

    $.fn.serializeObject = function () {
        var formData = {};
        var formArray = this.serializeArray();

        for (var i = 0, n = formArray.length; i < n; ++i)
            formData[formArray[i].name] = formArray[i].value;

        return formData;
    };

})(window.jQuery, window.pw);